import { useAuthStore } from '@stores/auth';
import { useBannersStore } from '@stores/banners.js';
import { useSharedStore } from '@stores/shared.js';
import { useFiltersStore } from '@stores/filters.js';
import { useReportsStore } from '@stores/reports.js';
import { useProductsStore } from '@stores/products.js';
import { useSettingsStore } from '@stores/settings.js';
import { useCausesStore } from '@stores/causes.js';
import { useFacilitiesStore } from '@stores/facilities.js';
import { useLanguagesStore } from '@stores/languages.js';
import { useNotificationsStore } from '@stores/notifications.ts';

/**
 * Resets all registered Pinia stores to their initial state.
 * Moved from @stores/index.js to prevent circular dependency.
 */
export const resetAllStoresUtil = () => {
    const stores = [
        useAuthStore,
        useBannersStore,
        useSharedStore,
        useFiltersStore,
        useReportsStore,
        useProductsStore,
        useSettingsStore,
        useCausesStore,
        useLanguagesStore,
        useNotificationsStore,
        useFacilitiesStore
    ];

    stores.forEach(useStore => {
        const store = useStore();
        store.resetState();
    });
};
